module.exports = __webpack_public_path__ + "static/media/dcb.90df1ec4.svg";